import React, { useEffect, useState } from 'react'
import './bill-view.scss'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import SinglePage from '../../components/common/page/SinglePage'
import SpinWithMessage from '../../components/common/spinners/SpinWithMessage'
import { accountingAxios } from '../../config/axios'
import { FaDotCircle } from 'react-icons/fa'
import { BsReceiptCutoff } from 'react-icons/bs'
import { TbReceipt2, TbTemplate } from 'react-icons/tb'
import { BiLoaderAlt } from 'react-icons/bi'
import { formatStringDate, formatAmount, decimalToNumber, convertBillToItemGrouping, convertBillToList } from '../../assets/javascript/formate-functions'
import SelectInput from '../../components/common/inputs/SelectInput'
import Modal from '../../components/common/modal/Modal'
import PayAmount from '../../components/user/finance/PayAmount'



function BillView() {
    const { bill_uuid } = useParams()
    const [data, setData] = useState({})
    const navigate = useNavigate()
    const [loading, setLoading] = useState('fetch')
    const [modal, setModal] = useState({ status: false })
    const [searchParams, setSearchParams] = useSearchParams()
    const [itemSections, setItemSections] = useState([])


    const buildBill = async () => {

        setLoading('bill')
        const res = await accountingAxios.get(`/p/download/pdf/bill/rf/${data?.reference?.type}/${data?.reference?.id}/${searchParams.get('view_type') === 'Item base' ? 'list' : 'group'}`, {
            responseType: "blob"
        })

        const blob = new Blob([res], {
            type: "application/pdf"
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `bill-${data?.reference?.id}.pdf`;
        link.click();

        window.URL.revokeObjectURL(url);

        setLoading('')

    }

    const buildReceipt = async () => {

        if (!decimalToNumber(data?.payment_summary?.paid_amount || 0) > 0) {
            return;
        }

        setLoading('receipt')
        const res = await accountingAxios.get(`/p/download/pdf/receipt/bn/${data?.bill_no}`, {
            responseType: "blob"
        })

        const blob = new Blob([res], {
            type: "application/pdf"
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `receipt-${data?.bill_no}.pdf`;
        link.click();

        window.URL.revokeObjectURL(url);

        setLoading('')
    }

    const handlePay = () => {
        setModal({
            status: true,
            title: "Pay Now",
            content: <PayAmount bill_no={data?.bill_no} payable_amount={decimalToNumber(data?.payment_summary?.due_amount || 0)} setModal={setModal} />
        })
    }


    useEffect(() => {
        accountingAxios.get(`/v2/bill/${bill_uuid}`).then((response) => {
            if (response.data) {
                setData(response.data)
                setLoading('')
            } else {
                navigate('/')
                setLoading('')
            }
        })

        if (!searchParams.get('view_type')) {
            setSearchParams('view_type=Group base')
        }

        // eslint-disable-next-line
    }, [])

    useEffect(() => {

        let a = []

        if (searchParams.get('view_type') === 'Group base') {
            a = convertBillToItemGrouping(data)
        } else {
            a = convertBillToList(data)
        }

        setItemSections(a)
        // eslint-disable-next-line
    }, [data, searchParams.get('view_type')])

    return (
        <div className='single-bill-view'>
            <Modal modal={modal} setModal={setModal} />
            <SinglePage titleArray={[`Bill View / ${data?.bill_no ?? 'Loading...'}`]}>
                {loading === 'fetch'
                    ? <SpinWithMessage message={'Fetch data...'} />
                    :
                    <>
                        <div className="top-div">
                            <SelectInput label='View Type' name='view_type' onChangeFun={(e) => setSearchParams(`view_type=${e.target.value}`)}
                                values={['Item base', 'Group base'].map((v) => ({ option: v, value: v, selected: v === searchParams.get('view_type') }))}
                                firstOption={{ option: 'Choose...', value: '' }} />
                            <div className="buttons-div">
                                {decimalToNumber(data?.payment_summary?.due_amount || 0) > 0 && <button style={{ backgroundColor: '#0066ff' }} onClick={handlePay}>Pay</button>}
                                <button onClick={() => navigate(`/payment-promises?bill_no=${data?.bill_no}`)}>Promises</button>
                                <button onClick={() => navigate(`/allocations?bill_no=${data?.bill_no}`)}>Allocations</button>
                                <button onClick={() => buildBill()}>{loading === 'bill'
                                    ? <span className='loading-icon'><BiLoaderAlt /></span>
                                    : <BsReceiptCutoff />} Bill</button>
                                {decimalToNumber(data?.payment_summary?.paid_amount || 0) > 0 &&
                                    <button onClick={() => buildReceipt()} >{loading === 'receipt'
                                        ? <span className='loading-icon'><BiLoaderAlt /></span>
                                        : <TbReceipt2 />} Receipt</button>}
                            </div>
                        </div>
                        <div className="single-border">
                            <div className="section-one">
                                {/* Service Details */}
                                <div className="card-div">
                                    <div className="head-div">
                                        <FaDotCircle />
                                        <h4>About Bill</h4>
                                    </div>
                                    <div className="content-div">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>Bill No & Version</td>
                                                    <td>: {data?.bill_no} - (V{data?.version})</td>
                                                </tr>
                                                <tr>
                                                    <td>Bill Type</td>
                                                    <td>: {data?.bill_type}</td>
                                                </tr>
                                                <tr>
                                                    <td>Issued Date</td>
                                                    <td>: {data?.bill_date ? formatStringDate(data?.bill_date) : 'Nil'}</td>
                                                </tr>
                                                <tr>
                                                    <td>Party Type</td>
                                                    <td>: {data?.party?.type} </td>
                                                </tr>
                                                <tr>
                                                    <td>Party Name & Id</td>
                                                    <td>: {data?.party?.id ?? ''}, {data?.party?.name ?? ''}</td>
                                                </tr>
                                                <tr>
                                                    <td>Reference Type</td>
                                                    <td>: {data?.reference?.type ?? ''}</td>
                                                </tr>
                                                <tr>
                                                    <td>Reference Id</td>
                                                    <td>: {data?.reference?.id ?? ''}</td>
                                                </tr>
                                                <tr>
                                                    <td>Bill Status</td>
                                                    <td>: <span className={` ${data?.status}-text text-badge`}>{data?.status}</span></td>
                                                </tr>
                                                {data?.status === 'VOIDED' && <tr>
                                                    <td>Void Reason</td>
                                                    <td>: {data?.void_reason}</td>
                                                </tr>}
                                                <tr>
                                                    <td>Currency & Taxable</td>
                                                    <td>: {data?.currency}  {data?.tax_applicable ? '(Tax Bill)' : "(Non tax Bill)"} </td>
                                                </tr>
                                                <tr>
                                                    <td>Source</td>
                                                    <td>: {data?.source} </td>
                                                </tr>
                                                <tr>
                                                    <td>Verification</td>
                                                    <td>: {data?.verified_by_type ? `Verified By ${data?.verified_by_type}` : 'Not verified'} </td>
                                                </tr>
                                                <tr>
                                                    <td>Creator</td>
                                                    <td>: {data?.bill_creator ? data?.bill_creator : 'SYSTEM'} </td>
                                                </tr>
                                                <tr>
                                                    <td>Created Date</td>
                                                    <td>: {data?.bill_created_at ? formatStringDate(data?.bill_created_at) : 'Nil'} </td>
                                                </tr>
                                                <tr>
                                                    <td>Identifier</td>
                                                    <td>: {data?.uuid} </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* Receipt details  */}
                                <div className="card-div">
                                    <div className="head-div">
                                        <FaDotCircle />
                                        <h4>Amount</h4>
                                    </div>
                                    <div className="content-div">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>Sub Total</td>
                                                    <td>: ₹{formatAmount(decimalToNumber(data?.pricing?.subtotal || 0))}</td>
                                                </tr>
                                                {data?.tax_applicable && < tr >
                                                    <td>Tax Amount</td>
                                                    <td>: ₹{formatAmount(decimalToNumber(data?.pricing?.tax_summary?.total_tax?.amount || 0))} </td>
                                                </tr>}
                                                <tr>
                                                    <td>Discount {data?.pricing?.discount?.value ? `(${data?.pricing?.discount?.value} ${data?.pricing?.discount?.type === 'FLAT' ? 'Flat' : '%'})` : ''} </td>
                                                    <td>: -₹{formatAmount(decimalToNumber(data?.pricing?.discount?.amount || 0))}</td>
                                                </tr>

                                                <tr className='underline-bold bold-text'>
                                                    <td>Grand Total</td>
                                                    <td>: ₹{formatAmount(decimalToNumber(data?.pricing?.grand_total || 0))}</td>
                                                </tr>
                                                <tr><td></td></tr>
                                                <tr><td></td></tr>
                                                <tr>
                                                    <td>Payment Status</td>
                                                    <td>: {data?.payment_summary?.status}</td>
                                                </tr>
                                                <tr>
                                                    <td>Paid amount</td>
                                                    <td>: ₹{formatAmount(decimalToNumber(data?.payment_summary?.paid_amount || 0))}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div className="section-two">
                                {data?.items?.length && <>
                                    {itemSections?.map((section) => {
                                        return <div className="card-div" key={section?.group_id}>
                                            <div className="head-div">
                                                <FaDotCircle />
                                                <h4>{section?.group_name}</h4>
                                            </div>
                                            <div className="content-div item-list">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>No</th>
                                                            <th>Item Id</th>
                                                            <th>Item Name</th>
                                                            <th>Category</th>
                                                            <th>Type</th>
                                                            <th>Product</th>
                                                            <th>MRP</th>
                                                            <th>Led. Cost</th>
                                                            <th>Charged</th>
                                                            <th>Qty</th>
                                                            {data?.tax_applicable && <th>Tax</th>}
                                                            <th>Total</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {section?.items?.map((item, index) => <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.item_id}</td>
                                                            <td>{item.item_name}</td>
                                                            <td>{item.item_category}</td>
                                                            <td>{item.item_type}</td>
                                                            <td>{item.product_type}</td>
                                                            <td>₹{formatAmount(item.unit_list_price || 0)}</td>
                                                            <td>₹{formatAmount(item.unit_ledger_cost || 0)}</td>
                                                            <td>₹{formatAmount(item.unit_charged_price || 0)}</td>
                                                            <td>{item.qty} {item?.unit}</td>
                                                            {data?.tax_applicable && <td>₹{formatAmount(item.tax || 0)}</td>}
                                                            <td style={{ fontWeight: 'bold' }}>₹{formatAmount(item.total || 0)}</td>
                                                        </tr>)}

                                                        <tr className='bold-text underline-bold'>
                                                            <td></td>
                                                            <td>Total</td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>₹{formatAmount(section.pricing?.list_total || 0)}</td>
                                                            <td>₹{formatAmount(section.pricing?.ledger_total || 0)}</td>
                                                            <td>₹{formatAmount(section.pricing?.sub_total || 0)}</td>
                                                            <td></td>
                                                            {data?.tax_applicable && <td>₹{formatAmount(section.pricing?.tax_amount || 0)}</td>}
                                                            <td style={{ color: 'blue' }}>₹{formatAmount(section.pricing?.grand_total || 0)}</td>

                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    })}
                                </>}
                                {!data?.items?.[0] &&
                                    <div className="no-receipt-div">
                                        <div className="receipt-border">
                                            <div className="box">
                                                < TbTemplate />
                                                <h5>No Items</h5>
                                            </div>
                                        </div>
                                    </div>}
                            </div>
                        </div>
                    </>}
            </SinglePage>
        </div >
    )
}

export default BillView